<template>
    <div class="card card-body">
        <owl-data-grid url="penyewaan" :columns="this.columns" @set-datas="(data) => datas = data">
            <div class="col-12 col-md-4" v-for="data in this.datas" v-bind:key=data>
                <router-link :to="{ name: 'penyewaan.pengajuan.update', params: { id: data.id } }" class="text-dark">
                    <div class="card card-body shadow mb-3">
                        <div class="h6 mb-0">{{ data.permohonan_nama }}</div>
                        <div>{{ data.alat_berat_nama }}</div>
                        <small>{{ data.permohonan_terhitung_mulai_tanggal_human_date }} - {{ data.permohonan_pengembalian_tanggal_human_date }}</small>
                    </div>
                </router-link>
            </div>
        </owl-data-grid>
    </div>
    <owl-floating-button to="penyewaan-pengajuan-create">
        <font-awesome-icon icon="plus"></font-awesome-icon>
    </owl-floating-button>
</template>

<script>
import OwlDataGrid from '@/components/OwlDataGrid.vue';
import OwlFloatingButton from '@/components/OwlFloatingButton.vue';

export default {
    name: 'Pengajuan',
    components: { OwlDataGrid, OwlFloatingButton },
    data() {
        return {
            datas: {},
            columns: [
                { data: 'Nama', name: 'permohonan_nama', orderable: true },
            ]
        }
    },

}
</script>